<div class="row">
  <app-contact-us class="spa0 col-12" />
  <app-explore-resources class="spa0 col-12"></app-explore-resources>
  <app-book-consultation
    [title]="title"
    (bookConsultEvt)="redirectFunction()"
    class="spa0 col-12" />
</div>
